/**
 * Admin Icons Component Library
 * Centralized icon components used across Admin module
 * Prevents duplication and ensures consistency
 */

import React from 'react';
import Svg, { Path, Circle, Line } from 'react-native-svg';
import { AdminColors } from '../constants/adminColors';

// ─── Search Icon ──────────────────────────────────────────────────────────────
export const SearchIcon = () => (
  <Svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke={AdminColors.gray350} strokeWidth="2">
    <Circle cx="11" cy="11" r="8" />
    <Path d="M21 21l-4.35-4.35" />
  </Svg>
);

// ─── Close Icon ───────────────────────────────────────────────────────────────
export const CloseIcon = () => (
  <Svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <Line x1="18" y1="6" x2="6" y2="18" />
    <Line x1="6" y1="6" x2="18" y2="18" />
  </Svg>
);

// ─── Info Icon ────────────────────────────────────────────────────────────────
interface InfoIconProps {
  size?: number;
  color?: string;
}

export const InfoIcon: React.FC<InfoIconProps> = ({ 
  size = 14, 
  color = '#1E5A7A' 
}) => (
  <Svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2">
    <Circle cx="12" cy="12" r="10" />
    <Path d="M12 16v-4" />
    <Path d="M12 8h.01" />
  </Svg>
);

// ─── Warning Icon ─────────────────────────────────────────────────────────────
interface WarningIconProps {
  size?: number;
  color?: string;
}

export const WarningIcon: React.FC<WarningIconProps> = ({ 
  size = 14, 
  color = '#995211' 
}) => (
  <Svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2">
    <Path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
    <Path d="M12 9v4" />
    <Path d="M12 17h.01" />
  </Svg>
);
